export * from './DetailPage';
export * from './DetailPageSGC';
